import { render, staticRenderFns } from "./DocumentCard.vue?vue&type=template&id=3e1cbb42&scoped=true&"
import script from "./DocumentCard.vue?vue&type=script&lang=js&"
export * from "./DocumentCard.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCard.vue?vue&type=style&index=0&id=3e1cbb42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1cbb42",
  null
  
)

export default component.exports